export const types = {
    GROUP: 'GROUP'
};
